import { CircularProgress } from '@material-ui/core';
import * as lib from '~/dependencies';
import { paddings, fonts, colors } from '~/layout';
import Bg from '~/assets/images/background_login_new.svg';

export const BoxLogin = lib.styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${paddings.contentLogin}px;

  .forgot-password-link {
    align-self: flex-start;
    font-size: ${fonts.default}px;
    cursor: pointer;
  }
  
  .forgot-password-link-back {
    align-self: center;
    font-size: ${fonts.default}px;
    cursor: pointer;
  }

  .cancel-security-code-button {
    font-size: ${fonts.default}px;
    cursor: pointer;
  }

  .resend-security-code-button {
    cursor: pointer;
    text-decoration: underline;
    &:active {
      color: #757575;
    }
  }

  .error {
    color: ${colors.red03};
  }
`;

export const BackgroundFloat = lib.styled.div`
  position: absolute;
  bottom: 0px;
  right: 0px;
  background: url(${Bg});
  width: 249px;
  height: 88px;
`;

export const Space = lib.styled.div`
  display: flex;
  height: ${props => props.height}px;
  width: 100%;
`;

export const Version = lib.styled.span`
  position: absolute;
  bottom: 0px;
  color: silver;
  font-size: 12px;
  margin-left: 5px;
  margin-bottom: 2px
`;

export const Message = lib.styled.div`
  text-align: center;
  font-size: ${props => props.fontSize}px;
  margin-top: 10px;
`;

export const IdiomSelector = lib.styled.div`
  position: absolute; 
  top: 25px;
  left: 12px;
`;

export const ThirdPartyLoginBtn = lib.styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  position: relative;
  width: 255px;
  height: 40px;
  border: 1px solid #dadce0;
  border-radius: 5px;
  outline: none;
  background: #fff;
  cursor: pointer;
  color: #3c4043;
  font-size: 14px;
  margin-bottom: 7px;

  span {
    margin-left: 5px;
  }

  &:hover {
    background: rgba(66,133,244,.04)!important;
    border: 1px solid #d2e3fc!important;
  }

  .icons {
    width: 20px;
    height: 20px;
    position: absolute;
    left: 0;
    margin: 10px;
  }
`;

export const Divider = lib.styled.span`
  font-size: 12px; 
  margin: 15px;
`;

export const CircularProgressStyled = lib.styled(CircularProgress)`
  color: ${colors.lightGray14}!important;
  width: 20px!important;
  height: 20px!important;
  position: absolute;
  right: 0;
  margin-right: 20px;
`;
